// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2RMNF","col":"Table_col__239_L","fulfillmentStatus":"Table_fulfillmentStatus__1gn7D","emailCol":"Table_emailCol__1chJf"};